import React, { useCallback, useEffect, type ChangeEvent } from 'react';
import { styled } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button, { ButtonGroup } from '@atlaskit/button';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { MODAL_STATE_SUCCESS } from '../../types';
import InstallationStatusModal from '../installation-status-modal/main.tsx';
import success from './assets/success.png';
import messages from './messages';
import type { Props } from './types';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ConfigureButton = styled(Button)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		textDecoration: 'inherit',
	},
});

const SuccessStatusModal = ({
	appName,
	setShouldRefetch,
	onConfigure,
	onMaybeLater,
	configurationUrl,
	analyticsAttributes = {},
}: Props) => {
	const { formatMessage } = useIntl();

	useEffect(
		() => () => {
			setShouldRefetch?.(true);
		},
		[setShouldRefetch],
	);

	const onConfigureClick = useCallback(
		(e: ChangeEvent<HTMLInputElement>, analyticsEvent: UIAnalyticsEvent) => {
			onConfigure && onConfigure();
			fireUIAnalytics(analyticsEvent, 'configureNow', analyticsAttributes);
		},
		[analyticsAttributes, onConfigure],
	);

	const handleMaybeLater = useCallback(
		(e: ChangeEvent<HTMLInputElement>, analyticsEvent: UIAnalyticsEvent) => {
			onMaybeLater && onMaybeLater();
			fireUIAnalytics(analyticsEvent, 'configureLater', analyticsAttributes);
		},
		[analyticsAttributes, onMaybeLater],
	);

	return (
		<>
			<InstallationStatusModal
				imageSrc={success}
				heading={formatMessage(messages.heading, { appName })}
				description={formatMessage(messages.body)}
				installationState={MODAL_STATE_SUCCESS}
			>
				<ButtonGroup>
					<ConfigureButton
						// @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLInputElement>, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(e: MouseEvent<HTMLElement, MouseEvent>, analyticsEvent: UIAnalyticsEvent) => void'.
						onClick={onConfigureClick}
						appearance="primary"
						autoFocus
						href={configurationUrl}
						target="_blank"
						testId="marketplace-dialog.common.ui.success-status.configure-button"
					>
						{formatMessage(messages.configureAppButtonLabel)}
					</ConfigureButton>
					<Button
						appearance="subtle-link"
						// @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLInputElement>, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(e: MouseEvent<HTMLElement, MouseEvent>, analyticsEvent: UIAnalyticsEvent) => void'.
						onClick={handleMaybeLater}
						testId="marketplace-dialog.common.ui.success-status.maybe-later-button"
					>
						{formatMessage(messages.maybeLaterButtonLabel)}
					</Button>
				</ButtonGroup>
			</InstallationStatusModal>
		</>
	);
};

export default SuccessStatusModal;
